import type { ReactNode } from 'react';
import { Drawer, DrawerContent, DrawerDescription, DrawerFooter, DrawerHeader, DrawerTitle } from '@/components/ui/drawer';
import { cn } from '@/lib/utils';

/**
 * A bottom drawer you can drag down to close (Vaul, via shadcn/ui). The body
 * scrolls; the footer (buttons) stays put above the home indicator.
 */
export function AppDrawer({
  open,
  onOpenChange,
  title,
  description,
  children,
  footer,
  className,
  dismissible = true,
}: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  title: ReactNode;
  description?: ReactNode;
  children?: ReactNode;
  footer?: ReactNode;
  className?: string;
  dismissible?: boolean;
}) {
  return (
    <Drawer open={open} onOpenChange={onOpenChange} dismissible={dismissible} repositionInputs={false}>
      <DrawerContent className={className}>
        <DrawerHeader className="px-5 pt-4 pb-2 text-left">
          <DrawerTitle className="text-xl font-bold tracking-tight">{title}</DrawerTitle>
          {description ? <DrawerDescription className="text-[15px]">{description}</DrawerDescription> : <DrawerDescription className="sr-only">{title}</DrawerDescription>}
        </DrawerHeader>
        {children && <div className={cn('grid gap-5 overflow-y-auto px-5 pb-4')}>{children}</div>}
        {footer && <DrawerFooter className="px-5 pt-2 pb-[calc(16px+env(safe-area-inset-bottom))]">{footer}</DrawerFooter>}
      </DrawerContent>
    </Drawer>
  );
}
